module.exports = __webpack_public_path__ + "img/banner_zh.897e6aa9.png";